import { render, staticRenderFns } from "./MessagePlainTextBody.vue?vue&type=template&id=0b39f78c&scoped=true&"
import script from "./MessagePlainTextBody.vue?vue&type=script&lang=js&"
export * from "./MessagePlainTextBody.vue?vue&type=script&lang=js&"
import style0 from "./MessagePlainTextBody.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./MessagePlainTextBody.vue?vue&type=style&index=1&id=0b39f78c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b39f78c",
  null
  
)

export default component.exports